import { DEFAULT_MONTHLY_RECURRENCE_WEEKDAY } from '../utils/appointment';
import { getBrowserTimezone } from '../utils/common';
import type { BlockFormData } from './types';

export const REPEAT_TIMES_OPTIONS = Array.from({ length: 50 }, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1),
}));

export const INITIAL_BLOCK_FORM_DATA: BlockFormData = {
  provider: null,
  timezone: getBrowserTimezone(),
  date: null,
  startTime: '',
  endTime: '',
  isRepeating: false,
  recurrencePreset: 'none',
  repeatTimes: 1,
  monthlyNth: 1,
  monthlyWeekday: DEFAULT_MONTHLY_RECURRENCE_WEEKDAY,
  notes: '',
  notesJson: null,
};
